import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
    static values = { url: String, idsKey: String }

    perform(event) {
        event.preventDefault()
        const button = event.currentTarget
        const operation = button.dataset.bulkActionsOperationValue
        if (operation) this.sendRequest(operation, button.dataset.bulkActionsConfirmValue)
    }

    preview(event) {
        event.preventDefault()
        if (this.bulkController?.pending) return
        const ids = this.getSelectedIds()
        if (!ids.length) return alert("Select items first")
        const button = event.currentTarget
        const urlValue = button.dataset.bulkActionsUrlValue
        if (!urlValue) return
        const url = new URL(urlValue, window.location.origin)
        ids.forEach(id => url.searchParams.append(`${this.idsKeyValue || "ids"}[]`, id))
        if (button.dataset.bulkActionsStatusValue) url.searchParams.set("status", button.dataset.bulkActionsStatusValue)
        Turbo.visit(url, { frame: button.dataset.bulkActionsFrameValue || "remote_modal" })
    }

    async sendRequest(operation, prompt = null) {
        const bulk = this.bulkController
        if (!bulk || bulk.pending) return
        const ids = bulk.selectedIds()
        if (!ids.length) return alert("Select items first")
        const destructive = ["delete", "void", "cancel", "reverse", "reject"].includes(operation)
        const confirmation = prompt || (destructive ? `${operation.charAt(0).toUpperCase() + operation.slice(1)} ${ids.length} selected records?` : null)
        if (confirmation && !confirm(confirmation)) return

        const url = new URL(this.urlValue, window.location.origin)
        url.searchParams.set("operation", operation)
        bulk.setPending(true)
        try {
            const response = await fetch(url.toString(), {
                method: "POST",
                headers: this.headers(),
                body: JSON.stringify({ [this.idsKeyValue || "ids"]: ids })
            })
            if (response.headers.get("Content-Type")?.includes("text/vnd.turbo-stream.html")) {
                Turbo.renderStreamMessage(await response.text())
            } else {
                throw new Error(response.status === 403 ? "You do not have permission to perform this action." : "The request could not be confirmed. Refresh the list and check the records before trying again.")
            }
        } catch (error) {
            alert(error.message || "The request could not be confirmed. Refresh the list before trying again.")
        } finally {
            bulk.resetSelection()
            bulk.setPending(false)
        }
    }

    get bulkController() {
        const element = this.element.closest('[data-controller~="bulk"]')
        return element ? this.application.getControllerForElementAndIdentifier(element, "bulk") : null
    }

    getSelectedIds() {
        return this.bulkController?.selectedIds() || []
    }

    headers() {
        return {
            "Content-Type": "application/json",
            "X-CSRF-Token": document.querySelector("meta[name='csrf-token']")?.content || "",
            "Accept": "text/vnd.turbo-stream.html"
        }
    }
}
